import React from 'react';

export const NotImplemented = () => <div>Noch nicht implentiert</div>;
